import React, {Component} from 'react';
import './WordList.css';
import BishunPlayer from '../BishunPlayer/BishunPlayer'
import {Helmet} from 'react-helmet';
import fetch from "isomorphic-fetch";
import Videojs from "video.js";


export default class WordList extends Component {
    constructor(props) {
        super(props)
        //获取书的索引
        let {presspinyin, bookId, wordId} = props.params;
        //获取当前书的数据
        this.currentBookData = window.AllBooksForPress.filter(m => m.presspinyin === presspinyin)[0]["books"][bookId];
        // let {book_data: {lesson, courseBanner}, name} = this.currentBookData;
        // console.log("this.currentBookData........", this.currentBookData)
        this.state = {
            //显示de汉字
            currentWord: '',
            //当前汉字的数组
            // currentWords: lesson[wordId].words,
            currentWords: [],
            //当前书本的名字
            // currentBookName: name,
            currentBookName: null,
            //当前课程的名字
            // currentLessonName: lesson[wordId].name,
            currentLessonName: null,
            //课程封面图
            currentCoverImg: null,
            // currentCoverImg: courseBanner,
            videoUrl: null,
            isUseVideoPlay: (presspinyin === 'chuangyou' || presspinyin === 'sichuangchuangyou') ? true : false,
            isHaveVideo: false,
            detail: null
        }
    }

    handleOnBishunPlayerClosed = () => {
        this.setState({currentWord: ''})
    }

    componentDidMount() {
        // console.log("componentDidMount........")
        this.getWordList();
    }   


    //卸载书本组件
    componentWillUnmount() {
        // console.log('卸载书本组卷........')

    }

    //点击某个汉字 ，将亲北京色变为灰色
    handleClickWord = (word, courseid) => {
        let {isUseVideoPlay,currentWords} = this.state
        // console.log("word....", word)
        // let {book_data: {lesson}} = this.currentBookData;
        let {wordId} = this.props.params;
        // let tmpWords = lesson[wordId].words;
        let tmpWords =currentWords
        console.log("tmpWords.....", tmpWords)
        for (let i of tmpWords) {
            if (i.word.trim() === word) {
                i.isReaded = true;
            }
        }
        if (isUseVideoPlay) {
            //汉字视频
            let videoApiUrl = "https://www.gankao.com/api/video/playchinese";
            fetch(videoApiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify({
                    char: word,
                    courseid: courseid
                })
            }).then((res) => {
                res.json().then(videoData => {
                    let playUrl;
                    if (videoData.status === 200) {
                        playUrl = videoData.data.videoUrl.normal;
                        this.setState({videoUrl: playUrl, isHaveVideo: true})

                        let src = playUrl, height = 100, width = 100;
                        this.player = Videojs(
                            "custom-video",
                            {
                                height,
                                width,
                                bigPlayButton: true,
                                textTrackDisplay: false,
                                errorDisplay: false,
                                controlBar: true,
                                type: "application/x-mpegURL",
                                color: 'Blue',
                                constructor: true
                            },
                            function () {
                                this.play();
                            }
                        );
                        this.player.src({src});

                    } else {
                        this.setState({isHaveVideo: false})
                    }
                });
            });
        }

        this.setState({currentWords: tmpWords})
    }

    getWordList = () => {
        fetch(`https://www.gankao.com/api/newWord/word?lesson_id=${this.props.params.wordId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(data => {
            if (data && data.status === 200) {
                // console.log("获取单词列表成功:", data.data.detail);
                let bookDetail=data.data.detail
                this.setState({
                    currentWords: data.data.data,
                    detail:bookDetail ,
                    currentBookName: bookDetail.book_name,
                    currentLessonName: bookDetail.lesson_name,
                    currentCoverImg: bookDetail.course_banner,
                });
            }
        })
        .catch(err => {
            console.log('获取单词列表失败:', err);
        });
    }

    render() {
        let { currentWord,currentBookName, currentWords, currentLessonName, currentCoverImg, isHaveVideo, videoUrl, isUseVideoPlay, detail } = this.state;
        // let currentBookName=detail.book_name;
        //分别为书本的索引和课时的索引
        console.log("currentWord.....", currentLessonName)
        // console.log("videoUrl.....", detail.course_banner)
        return (
            <div className="TextBoxArea">
                <Helmet>
                    <meta name="gankao_sharable" content="1"/>
                    <meta name="wx_share_title" content={currentBookName}/>
                    <meta name="wx_share_content" content={currentLessonName}/>
                    <meta name="wx_share_link" content={window.location.href}/>
                    <meta name="wx_share_imgurl" content={currentCoverImg}/>
                    <title>
                        {currentBookName}
                    </title>
                </Helmet>
                {/* {!currentWord &&
                <Link to={`/press/${presspinyin}/book/${bookId}`}>
                    <div className="go_back">
                        <span
                            style={{width: "100%", marginRight: "10px", lineHeight: "100%"}}>
                        <img src="https://img.qiaoxuesi.com/market/indexImg/1528078756956.PNG" alt=""/>
                        </span>
                        返回目录
                    </div>
                </Link>
                }*/}
                {/*书的封面start*/}
                {!currentWord &&
                <div className="bookCover">
                    <div className="leftCoverImg">
                        <img
                            style={{height: "170px", border: "1px solid rgb(251, 245, 245)"}}
                            src={currentCoverImg}
                            alt=""/>
                    </div>
                    <div className="lesson_name_gk">
                        {currentLessonName}
                    </div>
                </div>
                }
                <div style={{height: "10px", backgroundColor: "rgb(248, 248, 248)"}}>
                </div>
                {/*书的封面end*/}

                {
                    isUseVideoPlay
                        ? <div style={{margin: '10px 10px 0', overflow: 'hidden'}}>
                            {currentWord &&
                            <div>
                                {/*{currentWord && videoUrl !== null && <video
                                    style={{width: '100%'}}
                                    src={videoUrl}
                                    loop={'loop'}
                                    autoplay
                                    controls={'controls'}
                                    poster={`https://bishunfile.qiaoxuesi.com/market/indexImg/poster.png`}>
                                    <source src={videoUrl}/>
                                    您的浏览器不支持 video 标签!
                                </video>
                                }*/}
                                {
                                    currentWord && videoUrl !== null ?
                                        <video id="custom-video"
                                               className="video-js"
                                               controls
                                               preload="auto"
                                               style={{width: '100%'}}
                                        />
                                        : <div style={{textAlign: 'center'}}>视频加载……</div>
                                }
                            </div>
                            }
                        </div>
                        : <div>
                            {currentWord &&
                            <BishunPlayer
                                key={'bishunplayer_' + this.state.currentWord}
                                onBishunPlayerClosed={this.handleOnBishunPlayerClosed}
                                word={currentWord}
                            />}
                        </div>
                }

                {/*灰色线条start*/}
                {currentWord &&
                <div style={{
                    height: "1px", position: "fixed", right: "0",
                    left: "0", top: isHaveVideo ? "230px" : "338px", maxWidth: "768px",
                    margin: "0 auto", boxShadow: "0 2px 4px #E5E5E5"
                }}>
                </div>}
                {/*灰色线条end*/}
                <div className="WordList"
                     style={{
                         top: isHaveVideo ? "270px" : (currentWord ? "345px" : "215px"),
                         paddingTop: !isHaveVideo ? "40px" : "unset"
                     }}>
                    {currentWords.length > 0 ? currentWords.map((item, index) => {
                        return <div
                            onClick={() => {
                                this.handleClickWord(item.word.trim(), item && (item.course ? item.course : 0))
                                this.setState({currentWord: item.word.trim()})
                            }}
                            className="textItemBox"
                            key={"lesson" + index}>
                            <div
                                style={{
                                    backgroundImage: item.isReaded
                                        ? "url(https://img.qiaoxuesi.com/market/indexImg/1528448292881.PNG)"
                                        : "url(https://img.qiaoxuesi.com/market/indexImg/1527057138792.PNG)"

                                }}
                                className="textItem">
                                {item.word}
                            </div>
                        </div>
                    }) : <div style={{color: "#666", fontSize: "24px", textAlign: "center"}}>加载中……</div>}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/WordList/WordList.js